import { useState } from 'react';
import { airportConnections } from '../../../mocks/transportationPage';

export default function AirportSection() {
  const [activeAirport, setActiveAirport] = useState(1);

  return (
    <section id="airport" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <span className="inline-block bg-sky-100 text-sky-700 px-4 py-1.5 rounded-full text-xs font-semibold uppercase tracking-wide mb-4">
            Airport &amp; Rail
          </span>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Airport &amp; Regional Connections
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-sm">
            Roseville offers convenient access to Sacramento International Airport and
            Amtrak rail services for regional and national travel.
          </p>
        </div>

        {/* Tab Switcher */}
        <div className="flex justify-center mb-10">
          <div className="bg-gray-100 p-1 rounded-full inline-flex">
            {airportConnections.map((conn) => (
              <button
                key={conn.id}
                onClick={() => setActiveAirport(conn.id)}
                className={`px-6 py-3 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer flex items-center space-x-2 ${
                  activeAirport === conn.id
                    ? 'bg-sky-600 text-white shadow-lg'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                <i className={`${conn.icon} text-lg`}></i>
                <span>{conn.id === 1 ? 'SMF Airport' : 'Amtrak Station'}</span>
              </button>
            ))}
          </div>
        </div>

        {airportConnections
          .filter((c) => c.id === activeAirport)
          .map((conn) => (
            <div key={conn.id} className="grid lg:grid-cols-2 gap-10 items-center">
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{conn.name}</h3>
                <div className="flex items-center space-x-4 mb-6">
                  <span className="flex items-center space-x-1 text-sm text-gray-600">
                    <i className="ri-map-pin-line text-sky-500"></i>
                    <span>{conn.distance} from Roseville</span>
                  </span>
                  <span className="flex items-center space-x-1 text-sm text-gray-600">
                    <i className="ri-time-line text-sky-500"></i>
                    <span>{conn.driveTime} drive</span>
                  </span>
                </div>

                <div className="space-y-4">
                  {conn.options.map((opt, idx) => (
                    <div
                      key={idx}
                      className="flex items-start space-x-4 bg-sky-50 rounded-xl p-4 hover:bg-sky-100 transition-colors"
                    >
                      <div className="w-10 h-10 bg-sky-200 rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className={`${opt.icon} text-sky-700 text-lg`}></i>
                      </div>
                      <div>
                        <h4 className="font-semibold text-gray-900 text-sm">{opt.mode}</h4>
                        <p className="text-gray-600 text-sm">{opt.detail}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <a
                  href={
                    conn.id === 1
                      ? 'https://www.google.com/maps/dir/Roseville,+CA/Sacramento+International+Airport'
                      : 'https://www.google.com/maps/dir/Roseville,+CA/Sacramento+Valley+Station'
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center space-x-2 bg-sky-600 hover:bg-sky-700 text-white px-6 py-3 rounded-full font-semibold transition-colors cursor-pointer whitespace-nowrap mt-6"
                >
                  <i className="ri-direction-line"></i>
                  <span>Get Directions</span>
                </a>
              </div>

              <div className="relative w-full h-80 rounded-2xl overflow-hidden shadow-lg">
                {conn.id === 1 ? (
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m28!1m12!1m3!1d99456.5!2d-121.5!3d38.7!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m13!3e0!4m5!1s0x809b21d2a1c6e5e1%3A0x1e4f3b3b3b3b3b3b!2sRoseville%2C+CA!3m2!1d38.7521!2d-121.2880!4m5!1s0x809b2a1c6e5e1d21%3A0x3b3b3b3b3b3b3b3b!2sSacramento+International+Airport!3m2!1d38.6954!2d-121.5908!5e0!3m2!1sen!2sus!4v1"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Directions to SMF Airport"
                  />
                ) : (
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m28!1m12!1m3!1d99456.5!2d-121.5!3d38.7!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m13!3e0!4m5!1s0x809b21d2a1c6e5e1%3A0x1e4f3b3b3b3b3b3b!2sRoseville%2C+CA!3m2!1d38.7521!2d-121.2880!4m5!1s0x809ad12345678901%3A0xabcdef1234567890!2sSacramento+Valley+Station!3m2!1d38.5846!2d-121.5002!5e0!3m2!1sen!2sus!4v1"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Directions to Sacramento Valley Station"
                  />
                )}
              </div>
            </div>
          ))}
      </div>
    </section>
  );
}
